var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1284.5 482.58",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFF",
    d: "M413,305.08c20,77.2,169.83,50.17,243.5,29-84,7.2-119-33.33-126-54.5-14-98.4,111.83-178,176.5-205.5,149.4-63.2,218.58-19.67,234.5,10,29.5,70.5-48.5,143.17-89.5,171.5,214.8-112.8,223.17-196.17,200-223.5-70-74-288.5-2.83-389,42-196,87.44-255.5,185.5-250,231Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFF",
    d: "M0,66.58V5.58H500.5v61h-188.5V348.08h-123V66.58H0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFF",
    d: "M1284.5,5.58h-126V348.08h126V5.58Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFF",
    className: "cls-1",
    d: "M640,301.08c147.2-34,192.33-29.33,197.5-21.5,7.33,11.11-13.43,31.18-63.5,81-35.59,35.41-93.5,91.5-124.5,122,46.79-66.11,76.89-113.26,72.5-142-5.04-33-52.5-36.5-82-39.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.22d90271bc3d64594b7f00c9801b9b75.svg";
export { ForwardRef as ReactComponent };